import { makeStyles } from 'tss-react/mui';
import {
  AmexIcon,
  ApplePayIcon,
  DiscoverIcon,
  GooglePayIcon,
  JcbIcon,
  MaestroIcon,
  MasterCardIcon,
  PaypalIcon,
  VisaIcon,
} from './PaymentIcons';

const useStyles = makeStyles()(() => ({
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    margin: '1em 0',
    gap: '1em',
    flexWrap: 'wrap',
  },
}));

const PaymentOptions = () => {
  const { classes } = useStyles();
  return (
    <div className={classes.wrapper}>
      <VisaIcon />
      <PaypalIcon />
      <MaestroIcon />
      <MasterCardIcon />
      <GooglePayIcon />
      <ApplePayIcon />
      <DiscoverIcon />
      <JcbIcon />
      <AmexIcon />
    </div>
  );
};

export default PaymentOptions;
